module.exports = __webpack_public_path__ + "img/6_of_Hearts.svg.33ddad84.png";